import styled from 'styled-components'
import LanguagesList from './LanguagesList'
import Dialog from 'components/Common/Modals/Dialog'
import { useTranslation } from 'react-i18next'

const Content = styled.div`
  padding: 8px;
  display: flex;
  flex-direction: column;
`

const LanguagesListPopup = ({ onClose, list, value, onSelect }) => {
  const { t } = useTranslation()

  return (
    <Dialog.Wrapper onClose={onClose}>
      <Dialog.Main width={384}>
        <Dialog.Header
          title={t('accountSetup.languageSelectorDialog.select')}
          onClose={onClose}
        />
        <Dialog.Content>
          <Content data-testid='onboarding-header-language-popup'>
            <LanguagesList onSelect={onSelect} list={list} value={value} />
          </Content>
        </Dialog.Content>
      </Dialog.Main>
    </Dialog.Wrapper>
  )
}

export default LanguagesListPopup
